import React, { useContext, useState } from 'react';
import { Button, Modal } from 'antd';

import AmazonWebServicesContext from '@totem/components/administration/amazonWebServices/AmazonWebServicesContext';
import ModalFooter from '@totem/components/ui_components/dialogs/ModalFooter';
import ModalTitle from '@totem/components/ui_components/dialogs/ModalTitle';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { AWS_INSTANCES_ENDPOINT } from '@totem/utilities/endpoints';

const DeleteInstanceModal = () => {
  const { getApiToken } = useContext(UserProfileContext);
  const { selectedInstance, activeAction, onActionClose, onRefresh } =
    useContext(AmazonWebServicesContext);
  const [deleting, setDeleting] = useState<boolean>(false);

  if (activeAction !== 'delete' || !selectedInstance) {
    return null;
  }

  const handleDelete = () => {
    setDeleting(true);

    fetch(
      `${AWS_INSTANCES_ENDPOINT}/${selectedInstance.item.instance.instanceId}`,
      {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${getApiToken()}` },
      },
    ).then(() => {
      setDeleting(false);

      onActionClose();

      onRefresh();
    });
  };

  return (
    <Modal
      open
      title={<ModalTitle>Delete Instance Record</ModalTitle>}
      onCancel={onActionClose}
      footer={
        <ModalFooter>
          <Button onClick={onActionClose}>Cancel</Button>
          <Button
            danger
            type="primary"
            onClick={handleDelete}
            loading={deleting}
          >
            Delete
          </Button>
        </ModalFooter>
      }
    >
      <p>
        Delete the record for <strong>{selectedInstance.name}</strong> (
        {selectedInstance.item.instance.instanceId})?
      </p>
      <p>
        This removes it and its cost history from this report only — it does not
        affect the actual EC2 instance in AWS. Only do this once the instance
        has stopped syncing from the backend (e.g. it was terminated and no
        longer appears in AWS).
      </p>
    </Modal>
  );
};

export default DeleteInstanceModal;
